const CloseIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M21.0003 0L11.9989 9L2.99973 0L0 3L8.9992 12L0 21L2.99973 24L11.9989 15L21.0003 24L24 21L15.0008 12L24 3L21.0003 0Z"
            fill="white"
        />
    </svg>
)

CloseIcon.displayName = 'CloseIcon'

export default CloseIcon
